import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../lib/auth.jsx';

export default function Login() {
  const { t, i18n } = useTranslation();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totp, setTotp] = useState('');
  const [needTotp, setNeedTotp] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      await login(email, password, totp || undefined);
    } catch (err) {
      if (err.data?.error === 'totp_required') { setNeedTotp(true); setError(t('auth.totpRequired')); }
      else setError(t('auth.invalidCredentials'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <form className="auth-card" onSubmit={submit}>
        <div className="logo">
          <div className="logo-dot" />
          <div><strong>{t('app.name')}</strong></div>
        </div>
        <h1>{t('auth.signIn')}</h1>
        {error && <div className="error-banner">{error}</div>}
        <div className="field">
          <label>{t('auth.email')}</label>
          <input type="email" required value={email} onChange={e => setEmail(e.target.value)} autoFocus />
        </div>
        <div className="field">
          <label>{t('auth.password')}</label>
          <input type="password" required value={password} onChange={e => setPassword(e.target.value)} />
        </div>
        {needTotp && (
          <div className="field">
            <label>{t('auth.totp')}</label>
            <input inputMode="numeric" pattern="[0-9]*" value={totp} onChange={e => setTotp(e.target.value)} />
          </div>
        )}
        <button className="btn btn-primary" type="submit" disabled={busy} style={{ width: '100%', justifyContent: 'center' }}>
          {busy ? <span className="spinner" /> : t('auth.signInBtn')}
        </button>
        <div className="mt-16 muted" style={{ textAlign: 'center', fontSize: 12 }}>
          <select value={i18n.language} onChange={e => { i18n.changeLanguage(e.target.value); localStorage.setItem('lang', e.target.value); }}>
            <option value="en">English</option>
            <option value="sq">Shqip</option>
          </select>
        </div>
      </form>
    </div>
  );
}
